module.exports = __webpack_public_path__ + "static/img/digitalized_factory_bg.496df29.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product/digitalized_factory_bg.png
// module id = msRO
// module chunks = 0